import { render, staticRenderFns } from "./LocationSelector.vue?vue&type=template&id=52d52a91&"
import script from "./LocationSelector.js?vue&type=script&lang=js&"
export * from "./LocationSelector.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LocationSelector.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fheader%2FLocationSelector%2FLocationSelector.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports